var isSameQuarter = require('../is_same_quarter/index.js');
/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */


function isThisQuarter(dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate);
}

module.exports = isThisQuarter;